import { CaseStudyCard } from "@/components/case-studies/CaseStudyCard";
import {
  getPublishedCaseStudies,
  sortCaseStudies,
} from "@/utils/case-study.utils";

export default function CaseStudiesPage() {
  // Get all published case studies, sorted newest first
  const allCaseStudies = sortCaseStudies(getPublishedCaseStudies(), {
    field: "publicationDate",
    direction: "desc",
  });

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-[#9b87f5] to-[#B87333] text-white py-20">
        <div className="container mx-auto px-6">
          <div className="max-w-3xl">
            <h1 className="text-5xl font-extrabold mb-6">Our Work</h1>
            <p className="text-xl leading-relaxed opacity-95">
              Real results from real automation projects. See how we've helped
              businesses eliminate bottlenecks, reduce costs, and scale
              operations without scaling headcount.
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-12">
        <div className="container mx-auto px-6">
          {/* Case Studies Grid */}
          {allCaseStudies.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {allCaseStudies.map((caseStudy) => (
                <CaseStudyCard
                  key={caseStudy.metadata.id}
                  caseStudy={caseStudy}
                />
              ))}
            </div>
          ) : (
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-12 text-center">
              <svg
                className="mx-auto h-12 w-12 text-gray-400 mb-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                No case studies found
              </h3>
              <p className="text-gray-600">
                Check back soon for new case studies
              </p>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
